import React from 'react';
const GameLobbyPage: React.FC = () => (
  <div>Game Lobby (move lobby code here)</div>
);
export default GameLobbyPage;
